/** @format */
import {IconFillProps} from './model';

const IconProperty = ({fill}: IconFillProps) => (
  <svg width='70' height='12' viewBox='0 0 70 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1 8.60832L13.1429 7.06586L35.7083 11L52 7.90295L69 8.90295M1 4.4662L18.8095 2.28249L35.7083 7.17678L69 1'
      stroke={fill}
    />
  </svg>
);

export default IconProperty;
